import React from "react";
import { useImage } from "react-image";

export interface IImageProps {
  src: string | Array<string>;
  alt?: string;
}

const Image: React.FC<IImageProps> = ({ src, alt }): React.ReactElement => {
  const { src: source } = useImage({
    srcList: src,
    useSuspense: true,
  });
  return <img src={source} alt={alt} />;
};

export default Image;
